// src/components/BlogLayout.jsx
import React from "react";
import { Layout, Menu, Button, Avatar, Dropdown } from "antd";
import {
  UserOutlined,
  LoginOutlined,
  LogoutOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useBlogAPI";
import Footer from "./Footer";
import PageTransition from "./PageTransition";

const { Header, Content } = Layout;

// 获取用户头像的函数
const getUserAvatar = () => {
  const profile = localStorage.getItem("userProfile");
  if (profile) {
    try {
      const parsedProfile = JSON.parse(profile);
      return parsedProfile.avatarUrl;
    } catch (e) {
      return null;
    }
  }
  return null;
};

const BlogLayout = ({ children, user: propUser, onCreatePost }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: authUser } = useAuth();

  const currentUser = propUser !== undefined ? propUser : authUser;

  const getSelectedKey = () => {
    if (location.pathname === "/") return "home";
    if (location.pathname === "/archive") return "archives";
    if (location.pathname === "/categories") return "categories";
    if (location.pathname === "/about") return "about";
    return "";
  };

  const menuItems = [
    {
      key: "home",
      label: <Link to="/">首页</Link>,
    },
    {
      key: "categories",
      label: <Link to="/categories">分类</Link>,
    },
    {
      key: "archives",
      label: <Link to="/archive">归档</Link>,
    },
    {
      key: "about",
      label: <Link to="/about">关于</Link>,
    },
  ];

  const userMenuItems = currentUser
    ? [
        {
          key: "profile",
          label: "个人资料",
          onClick: () => navigate("/about"),
        },
        {
          key: "my-posts",
          label: "我的文章",
          onClick: () => navigate("/archive"),
        },
        {
          key: "logout",
          label: "退出登录",
          icon: <LogoutOutlined />,
          onClick: () => {
            localStorage.removeItem("authToken");
            localStorage.removeItem("userProfile");
            window.location.reload();
          },
        },
      ]
    : [
        {
          key: "login",
          label: "登录/注册",
          icon: <LoginOutlined />,
          onClick: () => navigate("/auth"),
        },
      ];

  // 获取用户头像URL
  const userAvatarUrl = getUserAvatar();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={{ position: "sticky", top: 0, zIndex: 1, width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
            <div
              className="logo"
              style={{
                color: "white",
                fontSize: 25,
                fontWeight: "bold",
              }}
            >
              我的博客
            </div>

            <Menu
              theme="dark"
              mode="horizontal"
              items={menuItems}
              style={{
                minWidth: 0,
                justifyContent: "flex-start",
                fontWeight: "normal",
              }}
              selectedKeys={[getSelectedKey()]}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            {currentUser && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onCreatePost || (() => navigate("/posts/create"))}
              >
                写文章
              </Button>
            )}

            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              {userAvatarUrl ? (
                <Avatar
                  src={userAvatarUrl}
                  alt="用户头像"
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <Avatar icon={<UserOutlined />} style={{ cursor: "pointer" }} />
              )}
            </Dropdown>
          </div>
        </div>
      </Header>
      <Content
        style={{
          padding: "24px 0",
          backgroundColor: "#ffffff",
        }}
      >
        <PageTransition location={location}>{children}</PageTransition>
      </Content>
      <Footer />
    </Layout>
  );
};

export default BlogLayout;
